import { useState } from 'react'
import { Select } from 'antd'
import MyDatePicker from '../../components/forms/datePicker'

const FilterPresentationSlot = ({
    filterValue,
    setFilterValue,
    setCurrentPage
}) => {
    const [tempfilterValue, setTempFilterValue] = useState({})

    let campusItems = [
        {
            value: 0,
            label: '全部'
        },
        {
            value: 1,
            label: '兰州职业技术学院'
        },
        {
            value: 2,
            label: '雁儿湾校区'
        },
        {
            value: 3,
            label: '桃林校区'
        }
    ]

    let statusItems = [
        {
            value: 0,
            label: '全部'
        },
        {
            value: 1,
            label: '可预约'
        },
        {
            value: 2,
            label: '已占用'
        },
    ]

    const clickCampusFilter = (value) => {
        setTempFilterValue({ ...tempfilterValue, campus: value })
    }

    const clickStatusFilter = (value) => {
        setTempFilterValue({ ...tempfilterValue, status: value })
    }

    const clickSubmitFilter = () => {
        setFilterValue({ ...filterValue, ...tempfilterValue })
        setCurrentPage(1)
    }

    const clickResetFilter = () => {
        setFilterValue({ ...filterValue, campus: 0, status: 0, date: '' })
        setTempFilterValue({})
    }

    return (
        <div className='public-conditions'>
            <div className='public-conditions-row'>
                <div className='public-condition'>
                    <div className='public-condition-label'>校区：</div>
                    <Select
                        value={tempfilterValue.campus}
                        placeholder="请选择"
                        options={campusItems}
                        style={{ width: '220px' }}
                        onChange={(value) => clickCampusFilter(value)}
                    />
                </div>
                <div className='public-condition'>
                    <div className='public-condition-label'>日期：</div>
                    <MyDatePicker
                        id="date"
                        placeholder="请选择日期"
                        value={tempfilterValue.date}
                        onChange={setTempFilterValue}
                        styles={{ width: '220px', height: '32px', marginTop: '9px'}}
                    />
                </div>
                <div className='public-condition'>
                    <div className='public-condition-label'>状态：</div>
                    <Select
                        value={tempfilterValue.status}
                        placeholder="请选择"
                        options={statusItems}
                        style={{ width: '220px' }}
                        onChange={(value) => clickStatusFilter(value)}
                    />
                </div>
            </div>

            <div className='public-conditions-buttons'>
                <div className='public-conditions-button1' onClick={() => { clickSubmitFilter() }}>筛选</div>
                <div className='public-conditions-button2' onClick={() => { clickResetFilter() }}>重置</div>
            </div>
        </div>
    )
}

export default FilterPresentationSlot
